import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { redisCache } from './stores/mockStore';

const container = document.getElementById('root')!;
const root = createRoot(container);


root.render(
  <App
    isRemote={false}
    userId={258362}
    departmentId={14}
    holderTypeId={1}
    hospitalId={100}
    landingZoneUrl='https://dashboard-dev.qsight.net'
    redisCache={redisCache}
  />
);
